<template>
  <v-dialog v-model="show" fullscreen hide-overlay transition="dialog-bottom-transition">
    <v-card height="100%" width="100%" color="grey lighten-4">
      <v-container fill-height fluid grid-list-xs>
        <v-layout row wrap>
          <v-toolbar color="transparent" absolute fixed flat>
            <v-spacer></v-spacer>
            <v-btn icon
              @click="$emit('update:show', false)"><v-icon>close</v-icon></v-btn>
          </v-toolbar>
          <v-flex xs6 sm6 md6 lg6>
            <v-card color="transparent" flat>
              <v-card-text>
                <span class="display-1 font-weight-black">{{ this.details.title }}</span>
              </v-card-text>
              <v-card-text>
                <v-card height="60%" color="transparent" flat>
                  <v-container fill-height>
                  <v-layout align-center justify-center>
                    <v-img contain
                      :src="require('@/assets/background/'+this.details.image)"></v-img>
                  </v-layout>
                  </v-container>
                </v-card>
              </v-card-text>
              <v-card-text>
                <p>{{ this.details.description }}</p>
              </v-card-text>
            </v-card>
          </v-flex>
          <v-flex xs6 sm6 md6 lg6>
            <v-container fill-height>
              <v-layout align-center justify-center column>
                <v-card-text class="headline font-weight-black black-text">
                  <span> {{ $t('contactQuote') }} </span>
                </v-card-text>
                <v-card-text>
                  <v-form ref="contactForm">
                    <v-text-field
                      v-model="inputProduct"
                      :rules="this.inputRules"
                      :label="$t('contactFormProduct')"/>
                    <v-text-field
                      v-model="inputName"
                      :rules="this.inputRules"
                      :label="$t('contactFormName')"/>
                    <v-text-field
                      v-model="inputEmail"
                      :rules="this.inputRules"
                      :label="$t('contactFormEmail')"/>
                    <v-text-field
                      v-model="inputSubject"
                      :rules="this.inputRules"
                      :label="$t('contactFormSubject')"/>
                    <v-textarea
                      v-model="inputMessage"
                      :rules="this.inputRules"
                      :label="$t('contactFormMessage')" counter="200">
                    </v-textarea>
                  </v-form>
                </v-card-text>
                <v-card-actions class="pa-0">
                  <v-layout align-center justify-center>
                    <v-btn color="grey darken-3" large @click="submitForm" :loading="this.submitLoading">
                      <span class="white--text font-weight-bold">{{ $t('contactQuoteBtn') }}</span>
                    </v-btn>
                  </v-layout>
                </v-card-actions>
              </v-layout>
            </v-container>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'product-dialog',
  props: ['show', 'details'],
  data () {
    return {
      imageHeight: 500,
      inputProduct: '',
      inputName: '',
      inputEmail: '',
      inputSubject: '',
      inputMessage: '',
      submitLoading: false,
      inputRules: [
        v => !!v || this.$i18n.t('contactValidate')
      ]
    }
  },
  methods: {
    setSize () {
      this.imageHeight = window.innerHeight * 0.5
    },
    submitForm () {
      // this.submitLoading = true
      if (this.$refs.contactForm.validate()) {
        // this.submitLoading = false
      }
    },
    closeDialog () {
      this.inputProduct = ''
      this.inputName = ''
      this.inputEmail = ''
      this.inputSubject = ''
      this.inputMessage = ''
    }
  },
  mounted () {
    this.setSize()
  },
  watch: {
    show: function (val) {
      this.$refs.contactForm.reset()
      this.inputProduct = this.details.title
    }
  }

}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/dialogs/ProductDialog.vue